// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"Q_-z"};